import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { axiosInterceptor } from "..";
import { IPracticeResponse } from "../interface";

export const UseDailyPracticeReq = async (orgId: string, subUserId: string) => {
  const response = await axiosInterceptor.get<IPracticeResponse>(
    `progression-b2b/${orgId}/${subUserId}/daily-practice-time`
  );

  return response.data;
};

const useDailyPraticeTime = (
  orgId: string,
  subUserId: string,
  options?: Omit<Partial<UseQueryOptions<IPracticeResponse>>, "queryFn">
) => {
  return useQuery<IPracticeResponse, Error>({
    queryKey: ["DAILY_PRACTICE_TIME", orgId, subUserId],
    queryFn: () => {
      return UseDailyPracticeReq(orgId, subUserId);
    },

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchInterval: false,
    staleTime: Infinity,
    gcTime: undefined,

    ...options,
  });
};

export default useDailyPraticeTime;
